module.exports = __webpack_public_path__ + "img/position.102fabfc.png";